import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { ErrorCodeEditor } from '#src/routes/wizard/step-uis/adjudication/error-code-editor.js';
import { useSpecActions } from '#src/routes/wizard/step-uis/adjudication/use-spec-actions.js';
import { useTRPC } from '#src/trpc.js';
import { SpecAccessErrorBoundary } from '../spec-access-error-boundary.js';

export const Route = createFileRoute('/_authorization-gate/wizard/admin/error-codes/')({
	head: () => ({ meta: [{ title: 'Error Codes • Wizard Admin • Cadstrom' }] }),
	errorComponent: SpecAccessErrorBoundary,
	component: WizardAdminErrorCodesPage,
});

/**
 * The inference error codes over every property: the code viewer and editor, outside any
 * adjudication review. Reads retired codes too, so the editor's toggle reveals them without a
 * further read.
 *
 * @returns The page element.
 */
function WizardAdminErrorCodesPage() {
	const trpc = useTRPC();
	const queryClient = useQueryClient();

	const {
		data: { errorCodes },
	} = useSuspenseQuery(trpc.packageDataSpec.errorCode.list.queryOptions({ includeRetired: true }));

	const refetchCatalogue = useCallback(
		() => queryClient.invalidateQueries({ queryKey: trpc.packageDataSpec.errorCode.list.queryKey() }),
		[queryClient, trpc],
	);
	const spec = useSpecActions(refetchCatalogue);

	return (
		<div className='flex min-h-0 grow basis-0 flex-col p-3'>
			<ErrorCodeEditor
				className='grow'
				errorCodes={errorCodes}
				onAdd={spec.addErrorCode}
				onUpdate={spec.onUpdateErrorCode}
				onRetire={spec.onRetireErrorCode}
			/>
		</div>
	);
}
